<template>
  <popup
    heading="New Action"
    :show-text="showText"
    button-text="Action"
    button-style="success"
    :center-button="true"
    :round="round"
    :plain="plain"
    button-icon="fa fa-asterisk"
    :disableButton="disabled || readOnly"
    :disableSave="true"
    @save="onSaveDialog"
    @close="onCloseDialog">

    <action-details
      ref="ad" :row-data="actionData" :site-data="siteData" :siteId="siteId"
     :editMode="true" :adding="true" :hide-panel="true" :table-ref="tr" />

</popup>

</template>


<script>

import ActionDetails from '@/components/actions/ActionDetails'

export default {
  components: {
    ActionDetails
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    siteData: {
      type: Object,
      default: null
    },

    siteId: {
      type: Number
    },

    showText: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    plain: {
      type: Boolean,
      default: false
    },

    round: {
      type: Boolean,
      default: false
    },

    buttonType: {
      type: String,
      default: null
    },

    tableRef: {
      type: String,
      default: 'action-table'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },


  watch: {
    tableRef: function (newTR) {
      this.tr = newTR
    }
  },



  methods: {
    onSaveDialog () {
      this.$refs.ad.onSave()
    },
    onCloseDialog () {
      this.$refs.ad.onClose()
    }
  },

  data () {
    return {
      editing: this.editMode,
      tr: this.tableRef,
      actionData: this.rowData ? this.rowData : this.getTableStruct('actions')
    }
  },

  created () {
    this.actionData.actionBy = this.userName()
//    console.log('siteId', this.siteId, 'rowData', this.rowData)
  }
}

</script>



// WEBPACK FOOTER //
// GeneralAction.vue?60e4518c